module.exports = __webpack_public_path__ + "static/media/YM68_1.249b6014.jpg";